"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTrialActive = isTrialActive;
exports.isTrialExpired = isTrialExpired;
exports.getTrialDaysRemaining = getTrialDaysRemaining;
const types_1 = require("@fsp/types");
/**
 * Returns true if the org is on an active free trial (INACTIVE + expiry in the future).
 */
function isTrialActive(org) {
    return (org.subscriptionStatus === types_1.SubscriptionStatus.INACTIVE &&
        !!org.freeTrialExpiresAt &&
        new Date(org.freeTrialExpiresAt) > new Date());
}
/**
 * Returns true if the org had a free trial that has now expired (INACTIVE + expiry in the past).
 */
function isTrialExpired(org) {
    return (org.subscriptionStatus === types_1.SubscriptionStatus.INACTIVE &&
        !!org.freeTrialExpiresAt &&
        new Date(org.freeTrialExpiresAt) <= new Date());
}
/**
 * Returns the number of whole days remaining in the free trial, or 0 if expired/no trial.
 */
function getTrialDaysRemaining(org) {
    if (!org.freeTrialExpiresAt)
        return 0;
    const diff = new Date(org.freeTrialExpiresAt).getTime() - Date.now();
    if (diff <= 0)
        return 0;
    return Math.ceil(diff / (1000 * 60 * 60 * 24));
}
